<a rel="noopener" (click)="_ga4Service.ga4SelectContent('click_cta', 'botao_whatsapp')"
  href="https://api.whatsapp.com/send?phone=551130039590&text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20a%20tagCAIXA"
  target="_blank">
  <div
    class="w-12 h-12 flex justify-center items-center bg-white fixed bottom-[100px] right-4 lg:right-[28px] z-10 rounded-full bd-whatsapp shadow">
    <img src="assets/icons/whatsapp.svg" alt="whatsapp" class="w-8 h-8" />
  </div>
</a>